import { useEffect } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter, useLocation } from 'react-router-dom'
import StorefrontShell from './customer/StorefrontShell'
import OwnerShell from './owner/OwnerShell'
import { trackPageView } from './shared/analytics'

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false, retry: 1 } },
})

/**
 * Top-level split: `/manage` is the owner console (its own theme/auth/routes), everything else is
 * the branded customer storefront. Each shell renders its own top-level `<Routes>`, so their
 * absolute paths stay valid (no nesting one Routes' absolute paths under the other).
 */
function AppRoutes() {
  const { pathname } = useLocation()

  // A client-side navigation keeps the old scroll offset, so a link tapped from the footer opens
  // the new page already scrolled past its heading and looks like nothing loaded.
  // ponytail: no per-route scroll restoration on back/forward — add if anyone misses it.
  useEffect(() => {
    window.scrollTo(0, 0)
    trackPageView(pathname) // GA SPA page_view — runs on mount + every route change
  }, [pathname])

  const isOwner = pathname === '/manage' || pathname.startsWith('/manage/')
  return isOwner ? <OwnerShell /> : <StorefrontShell />
}

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </QueryClientProvider>
  )
}
